module.exports = __webpack_public_path__ + "img/home_image_4.e4944468.webp";